import type {ComponentType} from 'react';
import type {BlockInstance} from '../appearance-data';
import {HeroBlock} from './hero-block';
import {FeaturesBlock} from './features-block';
import {CtaBlock} from './cta-block';
import {RichTextBlock} from './richtext-block';
import {
  BannerBlock,
  ImageBlock,
  NewsletterBlock,
  TestimonialsBlock,
  FaqBlock,
  StatsBlock,
  GalleryBlock,
} from './more-blocks';
import {SearchBlock} from './search-block';
import {AdvancedSearchBlock} from './advanced-search-block';
import {AnnouncementBlock} from './announcement-block';
import {StoriesBlock} from './stories-block';
import {
  HowItWorksBlock,
  WhyUsBlock,
  ServicesBlock,
  BeforeAfterBlock,
  VideoBlock,
  PricingBlock,
  PartnersBlock,
  ContactCtaBlock,
  TimelineBlock,
  CountryCardsBlock,
} from './blocks-batch2';
import {
  ProgramCategoriesBlock,
  StudentJourneyBlock,
  ConsultantsBlock,
  AiPromoBlock,
  SuccessStoriesBlock,
  BlogArticlesBlock,
} from './blocks-batch3';
import {FeaturedBlock} from './featured-block';
import {
  SocialLinksBlock,
  LoginCtaBlock,
  LanguageSwitcherBlock,
} from './widget-blocks';

export interface BlockComponentProps {
  block: BlockInstance;
  props: Record<string, any>;
}

/**
 * Maps a block_type → its React component. Adding a future block = add its
 * component here (and a matching definition in the backend BlockRegistry).
 */
export const BLOCK_COMPONENTS: Record<string, ComponentType<BlockComponentProps>> = {
  hero: HeroBlock,
  features: FeaturesBlock,
  cta: CtaBlock,
  richtext: RichTextBlock,
  banner: BannerBlock,
  image: ImageBlock,
  newsletter: NewsletterBlock,
  testimonials: TestimonialsBlock,
  faq: FaqBlock,
  stats: StatsBlock,
  search: SearchBlock,
  'advanced-search': AdvancedSearchBlock,
  announcement: AnnouncementBlock,
  stories: StoriesBlock,
  gallery: GalleryBlock,
  'how-it-works': HowItWorksBlock,
  'why-us': WhyUsBlock,
  services: ServicesBlock,
  'before-after': BeforeAfterBlock,
  video: VideoBlock,
  pricing: PricingBlock,
  partners: PartnersBlock,
  'contact-cta': ContactCtaBlock,
  timeline: TimelineBlock,
  'country-cards': CountryCardsBlock,
  'program-categories': ProgramCategoriesBlock,
  'student-journey': StudentJourneyBlock,
  consultants: ConsultantsBlock,
  'ai-promo': AiPromoBlock,
  'success-stories': SuccessStoriesBlock,
  'blog-articles': BlogArticlesBlock,
  'featured-scholarships': FeaturedBlock,
  'featured-universities': FeaturedBlock,
  'featured-courses': FeaturedBlock,
  'featured-jobs': FeaturedBlock,
  'social-links': SocialLinksBlock,
  'login-cta': LoginCtaBlock,
  'language-switcher': LanguageSwitcherBlock,
};
